import React from 'react';

import { isDefined } from '../is';

import { useDebouncedCallback } from '.';

interface Props {
  ref: React.RefObject<HTMLElement>;
  widthToReact?: number;
}

export const useCalculateWidthOverflowing = ({ ref, widthToReact }: Props) => {
  const [isOverflowing, setIsOverflowing] = React.useState(false);

  const calculateNameOverflowing = React.useCallback(() => {
    if (!isDefined(ref.current)) {
      return;
    }
    const { scrollWidth, offsetWidth } = ref.current;

    setIsOverflowing(scrollWidth > offsetWidth);
  }, [ref]);

  const resizeCallback = useDebouncedCallback(calculateNameOverflowing);

  React.useEffect(() => {
    if (!isDefined(widthToReact)) {
      return;
    }

    resizeCallback();
  }, [widthToReact, resizeCallback]);

  return isOverflowing;
};
